import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Sparkles } from 'lucide-react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
    const hasProcessed = useRef(false);
    const navigate = useNavigate();
    const location = useLocation();
    const { setGoogleUser } = useAuth();

    useEffect(() => {
        // Use useRef to prevent double execution under StrictMode
        if (hasProcessed.current) return;
        hasProcessed.current = true;

        const processSession = async () => {
            try {
                const hash = location.hash;
                const params = new URLSearchParams(hash.replace('#', '?'));
                const sessionId = params.get('session_id');

                if (!sessionId) {
                    navigate('/login');
                    return;
                }

                const res = await axios.post(
                    `${API}/auth/google/session`,
                    { session_id: sessionId },
                    { withCredentials: true }
                );

                const userData = res.data.user;
                setGoogleUser(userData);
                navigate('/dashboard', { state: { user: userData }, replace: true });
            } catch (err) {
                console.error('Google auth error:', err);
                navigate('/login');
            }
        };

        processSession();
    }, []);

    return (
        <div className="min-h-screen bg-gradient-to-br from-slate-50 via-indigo-50/30 to-slate-50 flex items-center justify-center">
            <div className="text-center">
                <div className="inline-flex items-center justify-center w-16 h-16 ai-gradient rounded-2xl shadow-lg mb-4 animate-pulse">
                    <Sparkles className="w-8 h-8 text-white" />
                </div>
                <h2 className="text-xl font-semibold text-stone-900 mb-2" style={{ fontFamily: 'Manrope, sans-serif' }}>
                    Signing you in...
                </h2>
                <p className="text-stone-500 text-sm">Please wait while we set up your session</p>
            </div>
        </div>
    );
}
